
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"video-block"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.75 18.125a1.25 1.25 0 01-1.25 1.25h-15a1.25 1.25 0 01-1.25-1.25V1.875A1.25 1.25 0 012.5.625H15c.326 0 .64.127.873.355l2.5 2.402a1.249 1.249 0 01.377.895v13.848z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.532 13.675a.713.713 0 01-1.032-.638V8.213a.713.713 0 011.032-.638l4.824 2.412a.713.713 0 010 1.275l-4.824 2.413z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    